export const paymentsQueryKeys = {
  invoices: 'invoices',
  printInvoices: 'print-invoices',
  merchant: 'paymentsMerchant',
  merchantLogo: 'paymentsMerchantLogo',
  invoiceExport: 'invoiceExport',
  allRefunds: 'allRefunds',
  stripeExpressPublicKey: 'stripeExpressPublicKey',
  createPaymentRequest: 'createPaymentRequest',
  manualTemplates: 'manualTemplates',
  bnplTtpLink: 'bnplTtpLink',
  createTerminal: 'createTerminal',
  autoConnectReader: 'autoConnectReader',
  terminalLocation: 'terminalLocation',
};

export const getInterScreenQueryOptions = (staleTime?: number, retry: boolean | number = false) => ({
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  ...(!retry ? { retry: false } : typeof retry === 'number' ? { retry } : {}),
  ...(staleTime ? { staleTime } : {}),
});
